import React from 'react'

const PartyPalsPrivacy = () => {
  return (
    <div className='policy-div'>
          <h1>PartyPals</h1>
          <h2>Privacy Policy</h2>

          <h3>Information We Do Not Collect</h3>
          <p><span style={{fontWeight:'bold'}}>Personal Information: </span> 
          We do not collect any personally identifiable information about you, such as your name, email address, or phone number.
          </p>

          <p><span style={{fontWeight:'bold'}}>Usage Data: </span> 
            We do not collect any usage data about how you interact with our mobile application.
          </p>

          <p><span style={{fontWeight:'bold'}}>Device Information: </span> 
          We do not collect any information about your device, such as device model, operating system version, or unique device identifiers.
          </p>

          <h3>Information We Do Not Share</h3>
          <p><span style={{fontWeight:'bold'}}>Information We Do Not Share: </span> 
          We do not collect any information about your device, such as device model, operating system version, or unique device identifiers.
          </p>

          <h3>Changes to Our Privacy Policy</h3>
          <p>We reserve the right to modify this Privacy Policy at any time. If we make material changes to this policy, we will notify you here in this Privacy Policy or by other means, such as email, prior to the changes taking effect.</p>

          <h3>Contact Us</h3>
          <p>If you have any questions or concerns about our Privacy Policy, please contact us at thepaluniverse@gmail.com.</p>
    </div>
  )
}

export default PartyPalsPrivacy